
//Employee portal error codes
export const employeePortalErrorCodes = {
  ORGANIZATION_NOT_FOUND: 'organization_not_found',
  USER_NOT_FOUND: 'user_not_found',
  ACCESS_DENIED: 'access_denied',
}

//Error messages map
export const employeePortalErrorMessages = {
  [employeePortalErrorCodes.ORGANIZATION_NOT_FOUND]: 'Sorry, the organization you are trying to access does not exist.',
  [employeePortalErrorCodes.USER_NOT_FOUND]: 'Sorry, we couldn’t log you in.',
  [employeePortalErrorCodes.ACCESS_DENIED]: 'Your account is not eligible for training.',
}

//Organization slugs for white labelling
export const employeePortalOrgSlugs = {
  COATS: 'coats',
}
